/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * The layer a dynamic export definition was resolved from.
 */
export enum EnumDynamicExportDefinitionScope {
    /**
     * The definition belongs to the Mandant that runs it.
     */
    Mandant = 0,
    /**
     * The definition is a system-wide standard shared by every Mandant.
     */
    System = 1,
}
